module.exports = __webpack_public_path__ + "static/img/27.0ea327d1.png";